export function fg(flag: string) {
    const flags: Record<string, boolean> = {
        // "platform_dst_nav4_side_nav_default_collapsed_api": false,
        // "navx-2566-implement-fhs-rollout": false,
        // "navx-full-height-sidebar": false,
        // "jiv-20710-fix-nav-rerender": false,
        // "platform_fix_component_state_update_for_suspense": false,
        // "navx-2566-implement-fhs-rollout": false,
    };

    if (flag in flags) {
        console.log(`Returning ${flags[flag]} for ${flag}`);
        return flags[flag]!;
    }

    // console.log("Unknown flag:", flag);

    return true;
}
